import { render, staticRenderFns } from "./manualurg.vue?vue&type=template&id=1706a94e&scoped=true"
import script from "./manualurg.vue?vue&type=script&lang=js"
export * from "./manualurg.vue?vue&type=script&lang=js"
import style0 from "./manualurg.vue?vue&type=style&index=0&id=1706a94e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1706a94e",
  null
  
)

export default component.exports